import type { TeamBadge } from './api'

/** A badge as the API sends it: anything else is dropped, so nothing unexpected reaches a link or the page. */
export function isBadge(b: unknown): b is TeamBadge {
  const x = b as TeamBadge
  return Boolean(
    x &&
      typeof x.token === 'string' &&
      /^0x[0-9a-fA-F]{40}$/.test(x.token) &&
      typeof x.roleLabel === 'string' &&
      /^[A-Za-z -]{2,20}$/.test(x.roleLabel) &&
      typeof x.symbol === 'string' &&
      /^[A-Za-z0-9.$_-]{0,12}$/.test(x.symbol),
  )
}
